import React from 'react';
import { View, Text, Image } from 'react-native-web';

// Custom Component
import { Button } from '../../components';

// Root Navigation
import * as RootNavigation from '../../navigation/RootNavigation';
import RouteKeys from '../../navigation/RouteKeys';

// Configs
import GLOBAL from '../../configs/config_global';

export function Welcome() {
    // region MAIN RENDER
    const logoWidth = 220;
    return(
        <View style={{ width: '100%', flex: 1, alignItems: 'center', padding: 64, backgroundColor: '#FFF' }}>
            {/* Logo */}
            <Image
                source={require('../../images/logo_vendor_portrait.png')}
                style={{ width: logoWidth, height: (71 / 111) * logoWidth, marginTop: 64 }}
            />

            {/* Main Content */}
            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                {/* Welcome Text */}
                <Text style={{ fontSize: 40, fontWeight: '900', lineHeight: 56, textAlign: 'center' }}>
                    Reach New Customers
                    {'\n'}and Grow Your Business
                </Text>

                {/* Register Button */}
                <Button
                    style={{ marginTop: 48 }}
                    text={'New to Truckster Vendor'}
                    onPress={() => RootNavigation.navigate(RouteKeys.REGISTER)}
                />

                {/* Login Button */}
                <Button
                    style={{ backgroundColor: '#E1E2E9', marginTop: 8 }}
                    text={'Log in with email'}
                    textStyle={{ color: GLOBAL.COLOR.BASIC.BLACK_TWO }}
                    onPress={() => RootNavigation.navigate(RouteKeys.LOGIN)}
                />
            </View>
        </View>
    );
    // endregion
}
